import React from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { TextQuoteButton } from "./home/TextQuoteButton";
import { useContent, fill } from "../lib/content";

export const LocationQuoteCTA = () => {
  const c = useContent();
  return (
    <div data-testid="location-quote-block" className="mt-8">
      <div className="flex flex-wrap items-center gap-3">
        <TextQuoteButton testId="location-text-quote-btn" label={fill(c.hero.ctaLabel, c)} />
        <Link to="/tv-mounting-quote" data-testid="location-instant-quote-btn" className="inline-flex items-center gap-2 px-7 py-4 rounded-full border-2 border-white/30 text-white font-bold text-base md:text-lg hover:bg-white/10 transition-colors">
          <Zap className="w-5 h-5 text-[#3b9dff]" /> Instant Quote
        </Link>
      </div>
      <Link to="/#photo-quote" data-testid="location-upload-link" className="mt-4 inline-block text-sm text-slate-300 underline underline-offset-4 hover:text-white">On a computer? Upload a photo instead</Link>
    </div>
  );
};
